import React, { Component } from 'react';
import { Button, Row, Col, Container } from 'reactstrap';
import "../assets/css/bootstrap.min.css";
import downloadIcon from '../assets/DownloadWhite.webp';

export class Table extends Component {
    static displayName = Table.name;

    constructor(props) {
        super(props);
        this.myRef = React.createRef();
        this.exportFile = this.exportFile.bind(this);
    }

    postUploadFull(handsetID, endtime) {
        this.props.postUploadFull(handsetID, endtime);
    }

    showDetailedData(id) {
        this.props.getDataCaptureOneDetailed(id);
    }

    renderTable(data) {
        let contents =
                <div>
                    <div className="tableFix" style={{ "overflowY": "auto" }}>
                        <table ref={this.myRef} aria-labelledby="tabelLabel">
                            <thead>
                                <tr>
                                    <th>Capture ID</th>
                                    <th>Date (dd/mm/yyyy)</th>
                                    <th>Time (hh:mm:ss)</th>
                                    <th>GPS Lat</th>
                                    <th>GPS Long</th>
                                    <th>Depth Measured(mm)</th>
                                    {this.props.showAdvanced && <><th>Toe RL(m)</th>
                                    <th>Reflectivity(%)</th>
                                    <th>Points Collected</th></>}
                                    <th>Time to Collect(s)</th>
                                    <th>Capture Type</th>
                                    <th>Deleted</th>
                                    <th>Comment</th>
                                    {this.props.showAdvanced && <th>Detailed Data</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(row =>
                                    <tr style={{ textDecoration: JSON.parse(row.data).deleted ? 'line-through' : 'none'}} key={row.id}>
                                        <td>{row.id}</td>
                                        <td>{row.dateTimeLocalDateString}</td>
                                        <td>{row.dateTimeLocalTimeString}</td>
                                        <td>{JSON.parse(row.data).rovergpslat}</td>
                                        <td>{JSON.parse(row.data).rovergpslong}</td>
                                        <td>{row.depthhole_rounded}</td>
                                        {this.props.showAdvanced && <><td>{JSON.parse(row.data).toerl}</td>
                                        <td>{row.reflecthole_data}</td>
                                        <td>{JSON.parse(row.data).pointcount}</td></>}
                                        <td>{(JSON.parse(row.data).endtime - JSON.parse(row.data).starttime) / 1000}</td>
                                        <td>{row.capturetype_data}</td>
                                        <td>{row.deletedString}</td>
                                        <td>{row.commentString}</td>
                                        {this.props.showAdvanced && <td>
                                            {row.detailedDataAvailable == 0 &&
                                                <Button color="secondary" onClick={() => this.postUploadFull(JSON.parse(row.data).handsetID, JSON.parse(row.data).endtime)}>Request</Button>
                                            }
                                            {row.detailedDataAvailable == 1 &&
                                                <Button color="success" onClick={() => this.showDetailedData(row.id)}>Show</Button>
                                            }
                                            {row.detailedDataAvailable == 2 &&
                                                <div className="Pendbtn">
                                                    Pending
                                                </div>
                                            }
                                        </td>}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </div>

        return (
            <div >
                {this.props.showAdvanced && <Container fluid>
                    <Row>
                        <Col style={{ display: "flex", justifyContent: "flex-end", flexDirection: "row", padding: "5px" }} >
                            <Button onClick={this.exportFile}>
                                <img src={downloadIcon} />
                                Export to CSV
                            </Button>
                        </Col>
                    </Row>
                </Container>}

                {contents}

            </div>
        );
    }

    exportFile() {
        const table = this.myRef.current;
        if (!table) return;

        const rows = [];
        const headers = [];
        for (const th of table.querySelectorAll("thead th")) {
            headers.push('"' + (th.innerText || "").replace(/"/g, '""') + '"');
        }
        rows.push(headers.join(","));

        for (const tr of table.querySelectorAll("tbody tr")) {
            const cells = [];
            for (const td of tr.querySelectorAll("td")) {
                cells.push('"' + (td.innerText || "").replace(/"/g, '""') + '"');
            }
            rows.push(cells.join(","));
        }

        const csv = rows.join("\n");
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        const datestring = this.props.endDate.getFullYear() + "-" + (this.props.endDate.getMonth() + 1) + "-" + this.props.endDate.getDate() + "_" + String(this.props.endDate.getHours()).padStart(2, '0') + String(this.props.endDate.getMinutes()).padStart(2, '0');
        link.href = url;
        link.download = "Dipstick-" + this.props.selectedhardwareID + "_" + datestring + ".csv";
        link.click();
        URL.revokeObjectURL(url);
    }

    render() {
        let contents = this.renderTable(this.props.data);

        return (
            <div>
                {contents}
            </div>
        );
    }

}
